<div style="width: 100%;">
	<h3 *ngIf="dreams.length > 0" style="color : white;">{{ username }}'s Dreams</h3>
	<div style="width: 100%">
		<dream class="col-md-10 col-xs-12" *ngFor="let dream of dreams" [dream]="dream" style="margin-bottom: 50px;"></dream>
	</div>
</div>